import { render, staticRenderFns } from "./ForgotStaff.vue?vue&type=template&id=71e3c57e&"
import script from "./ForgotStaff.vue?vue&type=script&lang=js&"
export * from "./ForgotStaff.vue?vue&type=script&lang=js&"
import style0 from "./ForgotStaff.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotStaff.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ForgotStaff.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports